// extracted by mini-css-extract-plugin
export default {"virtualVisitCard":"VirtualVisitCard-module__virtualVisitCard--CIFJz","virtualVisitContentIcon":"VirtualVisitCard-module__virtualVisitContentIcon--zq21z"};